<template>



  <div class="bigScreen bigScreen2" style="overflow: hidden;">
        <Row class="allOut" style="height: 920px">
            <Col class="leftCon" v-show="show1">
                <h4><span v-text="theTopTime"></span>{{lunchState}}用餐人员</h4>
                <div class="bottom">
                    <Col v-show="!isHoliday" class="leftBg nui-scroll">
                    <span v-if="item.addnum===0" :id="item.username" @click="changIt" :class="is18PX(item.state,item.realname)" v-for="(item,index) in peopleList" :key="index" v-html="item.realname"></span>
                    <span v-if="item.addnum!==0" :id="item.username" @click="changIt" :class="is18PX(item.state,item.realname)" v-for="(item,index) in peopleList" :key="index">{{item.realname}}(加餐{{item.addnum}}份)</span>
                    </Col>
                    <Col v-show="isHoliday" class="leftBg nui-scroll">
                    	节假日暂无用餐安排
                    </Col>
                    <div class="btmLeft">
                        <p>
                            <span></span>正常报餐
                        </p>
                        <p>
                            <span></span>留餐
                        </p>
                        <p>
                            <span></span>不报餐
                        </p>
                        	<div @click="showModel" class="btnSet2" v-show="show1==true&&show2==false">本期菜单</div>
                    </div>
                    <div class="btmRight">
                        <div class="recivce">{{recviceStr}}</div>
                        <div class="bcClass">
                            实时报餐人数：<span>{{bcNum}}</span>人
                            <div  v-show="show1==true&&show2==true" class="btnSet"><Button @click="showModel" type="primary">本期菜单</Button></div>
                        </div>
                    </div>
                    <div v-show="show1 && !show2" class="btmLeft" style="width: 100%;position: absolute;bottom: 15px;">
                        <div @click="getleftData(0,0)" class="btmToday changBtm allItBtn">{{diyitian.format('MM月dd日')}}早餐</div>
                        <div @click="getleftData(0,1)" class="btmToday allItBtn">{{diyitian.format('MM月dd日')}}午餐</div>
                        <div @click="getleftData(0,2)" class="btmToday allItBtn">{{diyitian.format('MM月dd日')}}晚餐</div>
                        <div @click="getleftData(1,3)" class="btmToday allItBtn">{{new Date(diertian.getTime()).format('MM月dd日')}}早餐</div>
                        <div @click="getleftData(1,4)" class="btmToday allItBtn">{{new Date(diertian.getTime()).format('MM月dd日')}}午餐</div>
                        <div @click="getleftData(1,5)" class="btmToday allItBtn">{{new Date(diertian.getTime()).format('MM月dd日')}}晚餐</div>
                        <div @click="getleftData(2,6)" class="btmToday allItBtn">{{new Date(disantian.getTime()).format('MM月dd日')}}早餐</div>
                        <div @click="getleftData(2,7)" class="btmToday allItBtn">{{new Date(disantian.getTime()).format('MM月dd日')}}午餐</div>
                        <div @click="getleftData(2,8)" class="btmToday allItBtn">{{new Date(disantian.getTime()).format('MM月dd日')}}晚餐</div>
                        <div @click="getleftData(3,9)" class="btmToday allItBtn">{{new Date(disitian.getTime()).format('MM月dd日')}}早餐</div>
                        <div @click="getleftData(3,10)" class="btmToday allItBtn">{{new Date(disitian.getTime()).format('MM月dd日')}}午餐</div>
                        <div @click="getleftData(3,11)" class="btmToday allItBtn">{{new Date(disitian.getTime()).format('MM月dd日')}}晚餐</div>
                        <div @click="getleftData(4,12)" class="btmToday allItBtn">{{new Date(diwutian.getTime()).format('MM月dd日')}}早餐</div>
                        <div @click="getleftData(4,13)" class="btmAshita allItBtn">{{new Date(diwutian.getTime()).format('MM月dd日')}}午餐</div>
                        <div @click="getleftData(4,14)" class="btmAshita allItBtn">{{new Date(diwutian.getTime()).format('MM月dd日')}}晚餐</div>
                    </div>
                </div>
            </Col>
            <Col class="rightCon" v-show="show2">
                <h4>信息展示</h4>
                <div class="rightBottom">
                    <Col span="20" offset="2" style="position: relative;">
                        <swiper style="height: 800px;" :options="swiperOption" ref="mySwiper">
                            <swiper-slide v-for="(item,index) in swiperData" :key="index">
                                <h2 class="rightConR" ref="swiperTitle" style="text-align: center;" :style="setTitleSize(item.title)">{{item.title}}</h2>
                                <div class="rightConL">
                                	<swiper v-show="checkout(item.image)" :options="swiperOption2" ref="mySwiper2">
                                		<swiper-slide v-for="(item2,index2) in item.image" :key="index2">
                                			<img :src="getUrl(item2.url)" alt="" />
                                		</swiper-slide>
                                	</swiper>
                                	<video v-bind:class="{is100 : !show1 }" controls="" v-show="!checkout(item.image)" v-for="(item2,index2) in item.video" height="" style="margin: 0 auto;display: block;">
                                		<source :src="getUrl(item2.url)" type="video/mp4"></source>
                                	</video>
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div id="isScrollOut" class="smallIt nui-scroll" :class-option="classOption1">
                        	<div class="scrollDiv nui-scroll ql-editor" :class="{autoHeight : spanNum==0}" ref="swiperContent" style="width: 100%;">
                                <div class="swiperContent rightConR"  :class="{marginBig : spanNum==0 }"  id="swiperConNei" v-html="getHtml(swiperData)"></div>
                        	    <div style="margin-top: 50px;" :class="{marginBig : spanNum==0}" v-show="isScrollBl2" class="swiperContent rightConR" id="swiperConNei" v-html="getHtml(swiperData)"></div>
                            </div>
						</div>
                        <div class="swiper-pagination"><span v-for="item in swiperData" :key="item.title"></span></div>
                        <div style="display: none;"><span @click="toPre">&lt;&lt;</span>{{activeIndex+1}}/{{pageNum}}<span @click="toNext">&gt;&gt;</span></div>
                    </Col>
                </div>
            </Col>
        </Row>
        <Row class="bottomBtn">
            <div class="bottomLeft">JM内务管理</div>
            <div class="bottomRight"></div>
            <span @click="spanNum = 24;show1=true;show2=false;" class="toBlue">用餐</span>
            <span @click="spanNum = 0;show2=true;show1=false;">信息</span>
            <span  @click="spanNum = 12;show1=true;show2=true;">用餐+信息</span>
        </Row>
        <Modal
        	class="modelBig"
            v-model="modal1"
            title="本期菜单"
            @on-visible-change="getStatus"
            >
            <!--<span v-show="!maxSecond">持续显示菜单</span>-->
            <table class="bigScreenTab" border="">
                <tr>
                    <td>
                        日期
                    </td>
                    <td>
                        餐次
                    </td>
                    <td>
                        菜单
                    </td>
                </tr>
            </table>
            <table class="bigScreenTab" border="" v-for="(item,index) in dinnerData" :key="index">
                <tr>
                    <td rowspan="3"><span>{{item.dateStr}}</span></td>
                    <td>早餐</td>
                    <td class="menuTd" :class="isScrollLeft(item.breakfast)"><div class="menuTd2">{{item.breakfast}}</div></td>
                </tr>
                <tr>
                    <td>午餐</td>
                    <td class="menuTd" :class="isScrollLeft(item.lunch)"><div class="menuTd2">{{item.lunch}}</div></td>
                </tr>
                <tr>
                    <td>晚餐</td>
                    <td class="menuTd" :class="isScrollLeft(item.dinner)"><div class="menuTd2">{{item.dinner}}</div></td>
                </tr>
            </table>
        </Modal>

    <Modal
      title="验证口令"
      v-model="modal_auth"
      :mask-closable="false"
      :closable="false">

      <Form :model="formItem" :label-width="100" inline>
        <Form-item label="口令">
          <Input type="password" v-model="formItem.authValue" placeholder="请输入口令..."></Input>
        </Form-item>
        <Form-item>
          <Button type="primary" size="large" @click="checkAuth()">提交</Button>
        </Form-item>
      </Form>



      <div slot="footer">
        <!--<Button type="primary" size="large" @click="checkAuth()">验证</Button>-->

      </div>
    </Modal>
    </div>


</template>


<script>
    import ReconnectingWebSocket from 'reconnecting-websocket';
    import "assets/../global/setting";
    import "assets/../global/jq";
	import vueSeamlessScroll from 'vue-seamless-scroll';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    import 'vue-awesome-swiper';
    export default {
        data () {
          return{
          		numP: 0,
          		lalala: true,
          		canMove2: true,
          		canMove: false,
          		isKaishi: false,
          		to1: {},
          		to2: {},
          		tiNextArr: [],
          		timerArr: [],
          		timerOArr: [],
          		timerOArr2: [],
          		timerOArr3: [],
          		countNum: 30000,
          		gundongTimePart: {},
          		gundongTimePart2: {},
          		gunTimeObj: {},
          		gunTimeObj2: {},
          		isScrollBl2:false,
          		swiperTimer:{},
                socketOK:"getIt",
                websocket:{},
                socketTimer:{},
                diyitian:new Date(),
                diertian:new Date(),
                disantian:new Date(),
                disitian:new Date(),
                diwutian:new Date(),
          		reciveTimer:{},
          		isHoliday:false,
                theTopTime:"",
                lockEdTime:new Date(),
                curLunch: "breakfast",
                curDay: new Date().format("yyyy-MM-dd"),
                dateState:"今天",
                lunchState:"早餐",
          		titleStr:"",
                jsq:{},
          		isScrollBl:false,
          		swiperCon:{
          			content : "暂无内容"
          		},
          	    clickNum :0,
          	    eleHtml : "",
                jishiqi: {},
                dinnerData:[],
                date1: "",
                date2: "",
                maxSecond:true,
                modal1:false,
                show1: true,
                show2: false,
                spanNum: 12,
                peopleList : [],
                bcNum: 42,
                second: 0,
                activeIndex: 1,
                pageNum: 3,
                swiperOption: {
		          observer:true,
				  observeParents:true,
                  debugger: true,
                  pagination: {
                    el: '.swiper-pagination',
                    clickable :true
                },
//		          autoplay: {
//				    delay: 30000,
//                	disableOnInteraction: false,
//				  },
                },
                swiperOption2: {
		          observer:true,
				  observeParents:true,
		          noSwiping:true,
		          noSwipingSelector:"div",
                  debugger: true,
                  spaceBetween : 50,
		          autoplay: {
				    delay: 5000,
                  	disableOnInteraction: false,
				  },
                },
                shiduan:"dinner",
                recviceStr: "",
                inertvelTime:"23:59:00",
                swiperData: [
                ],
                classOption1:{
		        	step: 0.8,
        			direction: 1
		        },
            //验证口令弹出框属性
            modal_auth: true,

            formItem: {
              input: '',
              select: '',
              radio: 'male',
              checkbox: [],
              switch: true,
              date: '',
              time: '',
              slider: [20, 50],
              textarea: '',
              authValue:""
            }
            }
        },
        components: {
            swiper,
            swiperSlide,
            'marquee': vueSeamlessScroll,
},
destroyed() {
		this.websocket.close();
	},
	directives: {
		tapTuo: {
			inserted: function(el, binding, vNode) {
				let expression = binding.value;
				let handler = expression.name;
				let args = expression.args

				on(el, 'touchstart', (e) => {

						let startX = e.changedTouches[0].clientX;
						let startY = e.changedTouches[0].clientY;
						console.log('----', startY)
						once(el, 'touchend', (ev) => {
							let disX = Math.abs(ev.changedTouches[0].clientX - startX);
							let disY = Math.abs(ev.changedTouches[0].clientY - startY);
							console.log('----', disY)
							if(disX != 0 && disY != 0) {
								handler(args);
							}
						})
					})
				}
				}
			},
			watch: {
				spanNum(i) {
                  console.log(8888888);
                  console.log(i);
                  var ele = document.getElementsByClassName("bottomBtn")[0].children;
                var ele2 = document.getElementsByClassName("bigScreen")[0];
        		var ele3 = document.getElementById("isScrollOut");
                ele2.classList.remove("bigScreen2");
                ele2.classList.remove("bigScreen3");
                for(var j=0;j<ele.length;j++){
                    ele[j].classList.remove("toBlue");
                }
                if(i==0){
                	this.scrollChangeOut()
//              	this.isScrollBl = true;
//              	this.scrollChangeOut()

					this.$nextTick(() => {
            			this.scrollChangeOut()
        				var eleN = document.getElementById('isScrollOut')
						eleN.scrollTop = 0
						this.setSoonGun2()
					})

                    ele[3].classList.add("toBlue");
                    ele2.classList.add("bigScreen3");
                    ele3.classList.add("bigIt");
                } else if(i == 24){
                	this.scrollChangeOut()
                    ele2.classList.add("bigScreen2");
                    ele[2].classList.add("toBlue");
//                  this.getFirst();
                } else if(i == 12){
//                  this.getFirst();

					this.$nextTick(() => {
            			this.scrollChangeOut()
						var eleN = document.getElementsByClassName('scrollDiv')[0]
						eleN.scrollTop = 0
						this.setSoonGun()
					})

                    ele[4].classList.add("toBlue");
                    ele3.classList.remove("bigIt");
                }
                // this.dateState='今天';
                // this.lunchState='早餐';
                // this.getleftData();
//              setTimeout(()=>{
//              	this.ifScroll();
//              },100)
            },
            activeIndex(i){
            	this.swiperCon = this.swiperData[i];
            	var ele = document.getElementsByClassName('scrollDiv')[0]
            	if (this.numP > 0) {
            		this.numP++
            		this.tiNextArr.map((item) => {
            			window.clearTimeout(item)
            		})
        			this.scrollChangeOut()
            		if (this.spanNum == 0) {
            			this.$nextTick(() => {
	            			this.scrollChangeOut()
	        				var eleN = document.getElementById('isScrollOut')
							eleN.scrollTop = 0
							window.clearTimeout(this.to1)
							this.to1 = setTimeout(() => {
								this.setSoonGun2()
							}, 2000)

						})
            		} else if (this.spanNum == 12) {
            			this.$nextTick(() => {
	            			this.scrollChangeOut()
							var eleN = document.getElementsByClassName('scrollDiv')[0]
							eleN.scrollTop = 0
							window.clearTimeout(this.to2)
							this.to2 = setTimeout(() => {
								this.setSoonGun()
							})
						})
            		}
            	}
            }
        },
        methods:{
          success () {
            this.$Notice.success({
              title: '口令正确',
              desc: ""
            });
          },
          error () {
            this.$Notice.error({
              title: '口令错误',
              desc: ""
            });
          },
          //验证方法
          checkAuth(value){
            console.log('authValue:'+this.formItem.authValue)
            if (this.formItem.authValue == 'Jm@20220613') {
              console.log('auth_check_true')
              this.success()
              this.modal_auth = false
            }else {
              console.log('auth_check_false')
              this.error()
            }
          },


        	zc () {
        		var i = 0
				var eleN = document.getElementById('isScrollOut')
    			var ele = document.getElementsByClassName('scrollDiv')[0]
    			this.tiNextArr.map((item) => {
        			window.clearTimeout(item)
        		})
    			eleN.addEventListener('touchstart', (e) => {
    				this.tiNextArr.map((item) => {
	        			window.clearTimeout(item)
	        		})
    				this.stopScroll2()
    			})
    			ele.addEventListener('touchstart', (e) => {
    				this.tiNextArr.map((item) => {
	        			window.clearTimeout(item)
	        		})
    				this.stopScroll()
    			})
        	},
        	setSoonGun2 () {
        		var i = 0
        		this.countNum = 30000
    			this.canMove = false
        		this.timerArr.push(setInterval(() => {
            		this.$nextTick(function(){
        				var ele = document.getElementById('isScrollOut')
            			if (this.countNum == ele.scrollTop && i > 300) {
					  	 	this.canMove = true
            				this.overGundongTimePart2()
            			} else {
					  	 	this.countNum = ele.scrollTop
					  	 	ele.scrollTop = ele.scrollTop + 1;
					  	 	i++
            			}

				  	})
            	},13))
        	},
        	setSoonGun () {
        		var i = 0
        		this.countNum = 30000
    			this.canMove = false
        		this.timerArr.push(setInterval(() => {
            		this.$nextTick(function(){
            			var ele = document.getElementsByClassName('scrollDiv')[0]
            			if (this.countNum == ele.scrollTop && i > 300) {
					  	 	this.canMove = true
            				this.overGundongTimePart()
            			} else {
					  	 	this.countNum = ele.scrollTop
					  	 	ele.scrollTop = ele.scrollTop + 1;
					  	 	i++
            			}

				  	})
            	},13))
        	},
        	setThreePartScroll () {
        		this.countNum = 30000
        		this.scrollChangeOut()
            	var ele = document.getElementsByClassName('scrollDiv')[0]
	            this.timerOArr2.push(setTimeout(() => {
//					ele.scrollTop = 0
        			this.canMove = false
	            	this.timerArr.push(setInterval(() => {
	            		this.$nextTick(function(){
			            	ele = document.getElementsByClassName('scrollDiv')[0]
	            			if (this.countNum == ele.scrollTop) {
						  	 	this.canMove = true
	            				this.overGundongTimePart()
	            			} else {
						  	 	this.countNum = ele.scrollTop
						  	 	ele.scrollTop = ele.scrollTop + 1;
	            			}
					  	})
	            	},13))
	            }, 2000))
            },
            setThreePartScroll2 () {
        		this.countNum = 30000
        		this.scrollChangeOut()
        		var ele = document.getElementById('isScrollOut')
	            this.timerOArr.push(setTimeout(() => {
//					ele.scrollTop = 0
        			this.canMove = false
	            	this.timerArr.push(setInterval(() => {
	            		this.$nextTick(function(){
        					ele = document.getElementById('isScrollOut')
	            			if (this.countNum == ele.scrollTop) {
						  	 	this.canMove = true
	            				this.overGundongTimePart2()
	            			} else {
						  	 	this.countNum = ele.scrollTop
						  	 	ele.scrollTop = ele.scrollTop + 1;
	            			}

					  	})
	            	},13))
	            }, 2000))
            },
            overGundongTimePart () {
            		var that = this
	    			this.scrollChangeOut()
	            	this.tiNextArr.push(setTimeout(() => {
	            		this.$refs.mySwiper.swiper.slideTo((that.$refs.mySwiper.swiper.activeIndex+1) % that.$refs.mySwiper.swiper.slides.length);
		            	this.$nextTick(() => {
							var eleN = document.getElementsByClassName('scrollDiv')[0]
							eleN.scrollTop = 0
							window.clearTimeout(this.to2)
							this.to2 = setTimeout(() => {
								this.setSoonGun()
							})
						})
	            	}, 3000))
//          	this.timerOArr3.push(setTimeout(() => {
//          		var ele = document.getElementsByClassName('scrollDiv')[0]
//					ele.scrollTop = 0
//          		this.setThreePartScroll()
//          	}, 2000))
            },
            overGundongTimePart2 () {
	            	var that = this
	            	this.scrollChangeOut()
	            	this.tiNextArr.push(setTimeout(() => {
	            		this.$refs.mySwiper.swiper.slideTo((that.$refs.mySwiper.swiper.activeIndex+1) % that.$refs.mySwiper.swiper.slides.length);
	            		this.$nextTick(() => {
	        				var eleN = document.getElementById('isScrollOut')
							eleN.scrollTop = 0
							window.clearTimeout(this.to1)
							this.to1 = setTimeout(() => {
								this.setSoonGun2()
							})

						})
	            	}, 3000))
//          	this.timerOArr3.push(setTimeout(() => {
//      			var ele = document.getElementById('isScrollOut')
//					ele.scrollTop = 0
//          		this.setThreePartScroll2()
//          	}, 2000))
            },
            // 清空所有定时器
            scrollChangeOut () {
            	this.timerArr.map(item => {
            		window.clearInterval(item)
            	})
            },
        	stopScroll () {
        		if (this.spanNum == 12) {
        			this.canMove = false
        			this.canMove2 = false
            		this.scrollChangeOut()
        			window.clearTimeout(this.gunTimeObj)
        			this.gunTimeObj = setTimeout(() => {
	        			this.setJixu()
	        		}, 5000)
//      			setTimeout(() => {
//      				this.canMove = true
//	        		}, 8500)
        		}
        	},
        	setJixu () {
        		var i = 0
        		this.scrollChangeOut()
        		setTimeout(() => {
        			this.canMove = false
        			this.timerArr.push(setInterval(() => {
	            		this.$nextTick(function(){
	        				var ele = document.getElementsByClassName('scrollDiv')[0]
	            			if (this.countNum == ele.scrollTop && i > 400) {
						  	 	this.canMove = true
	            				this.overGundongTimePart()
	            			} else {
						  	 	this.countNum = ele.scrollTop
						  	 	ele.scrollTop = ele.scrollTop + 1;
						  	 	i++
	            			}

					  	})
	            	},13))
        		}, 50)
        	},
        	stopScroll2 () {
        		if (this.spanNum == 0) {
        			this.canMove = false
            		this.scrollChangeOut()
        			window.clearTimeout(this.gunTimeObj2)
        			this.gunTimeObj2 = setTimeout(() => {
	        			this.setJixu2()
	        		}, 5000)
//      			setTimeout(() => {
//      				this.canMove = true
//	        		}, 8500)
        		}
        	},
        	setJixu2 () {
        		var i = 0
        		this.scrollChangeOut()
            	setTimeout(() => {
        			this.canMove = false
            		this.timerArr.push(setInterval(() => {
	            		this.$nextTick(function(){
	        				var ele = document.getElementById('isScrollOut')
	            			if (this.countNum == ele.scrollTop && i > 400) {
						  	 	this.canMove = true
	            				this.overGundongTimePart2()
	            			} else {
	            				i++
						  	 	this.countNum = ele.scrollTop
						  	 	ele.scrollTop = ele.scrollTop + 1;
	            			}

					  	})
	            	},13))
            	}, 50)
        	},
        	setTitleSize(title){
        		if(this.spanNum == 0){
        			var len = 54 - ((Math.ceil(title.length - 23)));
	        		if(title.length>23){
	        			return "font-size: "+len+"px";
	        		}
        		}else{
        			var len = 44 - ((Math.ceil(title.length - 23)*0.5));
	        		if(title.length>30){
	        			return "font-size: "+len+"px";
	        		}
        		}
        	},
        	is18PX(a,str){
        		if(str.length<=4){
        			return a
        		}else{
        			return a+" "+"haveBr";
        		}
        	},
        	recivce(){
                var ele = document.getElementsByClassName("recivce")[0];
                var second = this.recviceStr.length/6*1000;
                var height = this.recviceStr.length*15.758;
                if(this.recviceStr.length > 20){
                	$(".recivce").animate({"right":height+"px"} ,second, "linear",function(){
                        $(".recivce").css({"right":0});
                    });
                	this.reciveTimer = setInterval(()=>{
                		$(".recivce").animate({"right":height+"px"} ,second, "linear",function(){
	                        $(".recivce").css({"right":0});
	                    });
                	},second)
                }else{
                	window.clearInterval(this.reciveTimer);
                	$(".recivce").stop();
                	$(".recivce").css({"right":0});
                }
        	},
        	getTody(){
        		var time = new Date();
        	},
        	getDigui(e){
        		for(var i=0;i<365;i++){
        			var time = new Date(new Date().getTime()+(1000*60*60*24*i));
        			if(time.format("dd") - new Date().format("dd") > 7 ){
        				console.log(time);
        				return time;
        			}
        		}
        	},
        	isOkDay(e){
                this.getLocked();
                var that = this;
                let params = {};
                params.url = "/sys/mealrecord/windowshow";
                params.data = {
                    meal_date: e.format('yyyy-MM-dd'),
                    meal_type: 'breakfast'
                };

                params.token = "swgykj9527";
                params.success=function(res){
                    return 0
                };
                that.ajaxPostWX(params);
        	},
        	getHtml(){
        		if(this.swiperData.length>0){
        			return this.swiperData[this.activeIndex].content;
        		}else{
        			return "<p style='width:300px'>暂无信息<p>";
        		}
        	},
            getTitleTime(e){
                if(this.dateState == "今天"){
                    return new Date(this.lockEdTime.getTime()).format('MM月dd日');
                }else{
                    return new Date(this.lockEdTime.getTime()+(60*60*1000*24)).format('MM月dd日');
                }
            },
            isScrollLeft(str){
                if(str.split("").length>32){
                    return "scrollLeft"
                }
            },
            scrollTd(){
                // $(".menuTd").each(function(i){
                //     console.log($(this)[0].innerText);
                // });
            },
        	ifScroll(){
        		var height = document.getElementById("swiperConNei").offsetHeight;
                var ele2 = document.getElementById("isScrollOut");
                ele2.style.position = "absolute";
        		var height2 = document.getElementById("isScrollOut").offsetHeight;
                var ele = document.getElementById("swiperConNei");
                var second = height * 10;
            	if(height > 410 && this.spanNum == 12){
                    this.isScrollBl = false;
                    this.digui();
            	}else if(height > 600 && this.spanNum == 0){
            		this.isScrollBl = true;
                    this.digui();
            	}else{
            		this.isScrollBl = false;
                    this.digui();
            	}
            },
            digui(e){
            	var that = this;
            	this.isScrollBl2 = false;
            	window.clearTimeout(this.swiperTimer);
            	$(".scrollDiv").stop();
            	$(".scrollDiv").css({"top":0});
        		if(this.isScrollBl){
                    setTimeout(()=>{
                    	var height = document.getElementById("swiperConNei").offsetHeight-120;
	                    var ele2 = document.getElementById("isScrollOut");
	                    var second = height *18;
	                    if(that.$refs.mySwiper.swiper.slides.length  ==  1){
            				that.isScrollBl2 = true;
                    		var height = document.getElementById("swiperConNei").offsetHeight+300;
                      }
	                    $(".scrollDiv").animate({top:-height+"px"} ,second, "linear",function(){
	                        $(".scrollDiv").css({"top":0});
	                        if(that.$refs.mySwiper.swiper.slides.length > 1){
	                        	that.$refs.mySwiper.swiper.slideTo((that.$refs.mySwiper.swiper.activeIndex+1) % that.$refs.mySwiper.swiper.slides.length);
	                        }else{
	                        	that.isScrollBl = true;
                				that.digui();
	                        }
	                    });
                    },200)
                }else{
                	this.$refs.swiperContent.scrollTo(0,0);
                	var that = this;
                    $(".scrollDiv").stop().css({"top":0});
                    that.swiperTimer = setTimeout(()=>{
                        that.$refs.mySwiper.swiper.slideTo((that.$refs.mySwiper.swiper.activeIndex+1) % that.$refs.mySwiper.swiper.slides.length);
                    },15000)
                }
            },
        	checkout(e){
        		var arr = [];
        		for(var i in e){
        			arr.push(i);
        		}
        		if(arr.length<2){
        			return false;
        		}else{
        			return true;
        		}
        	},
        	getUrl(e){
        		var ele = e.split(parameters.domain).length - 1;
    			return parameters.domain+e.split(parameters.domain)[ele];
        	},
            getStatus(status){
                if(!status){
                    var that = this;
                    that.modal1 = false;
                    window.clearInterval(that.jishiqi);
                    that.getSecond();
                }
            },
            showModel(){
                var that = this;
                var ele = document.getElementsByClassName("ivu-btn-primary")[1];
				if(this.clickNum == 0){
                	this.eleHtml = ele.innerHTML;
				}else{
					ele.innerHTML = this.eleHtml;
				}
				if(this.second && this.second < 1000){
                	ele.innerHTML = this.eleHtml+ "  ("+that.second+")";
				}
                this.searchDate();
                this.modal1 = true;
                this.clickNum++;
                this.jishiqi = setInterval(function(){
                    that.second = that.second - 1;
                    if(that.second == 0){
                        that.modal1 = false;
                        window.clearInterval(that.jishiqi);
                        that.getSecond();
                    }else if(that.second < 1000){
                		ele.innerHTML = that.eleHtml+ "  ("+that.second+")";
                    }
                },1000)
                setTimeout(() => {
                    this.scrollTd();
                }, 100);
            },
            searchDate(){
                this.date1 = this.getDate()[0];
                this.date2 = this.getDate()[1];
                if(this.date2<this.date1){
                    this.$Message.error({
                        content: "其填写正确是时间区间"
                    });

                }else{
                    var that = this;
                    this.dinnerData = [];
                    var curDate = new Date();
		            var curMonth = curDate.getMonth();
		            curDate.setMonth(curMonth + 1);
		            curDate.setDate(0);
//                  var len = (parseInt(this.date2.format("dd"))-parseInt(this.date1.format("dd")))+1;
//                  if(len<0){
//                  	len = curDate.getDate()-parseInt(this.date1.format("dd")) + parseInt(this.date2.format("dd")) + 1;
//                  }
					var week = ["星期一","星期二","星期三","星期四","星期五"];
					var len = 5;
                    for(var i=0;i<len;i++){
//                      var n;
//                      if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 1){
//                          n = "一";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 2){
//                          n = "二";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 3){
//                          n = "三";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 4){
//                          n = "四";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 5){
//                          n = "五";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 6){
//                          n = "六";
//                      }else if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 0){
//                          n = "日";
//                      }
                        // if(new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 6 || new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).getDay() == 0){

                        // }else{
                            var obj = {
                                date: new Date(this.date1.getTime()+ (i * 24 * 60 * 60 * 1000 )).format("yyyy-MM-dd"),
                                dateStr: week[i],
                                breakfast: "",
                                lunch: "",
                                dinner:""
                            };
                            this.dinnerData.push(obj);
                        // }
                    }
                    var params = {
                        data: {},
                        token: "swgykj9527",
                        url: '/sys/bookmealsetting/list',
                        success: (res) => {
                        	var data = res.data.result.result[0];
		                  	that.dinnerData[0].breakfast = data.Monday_breakfast;
		                  	that.dinnerData[0].lunch = data.Monday_lunch;
		                  	that.dinnerData[0].dinner = data.Monday_dinner;
		                  	that.dinnerData[1].breakfast = data.Tuesday_breakfast;
		                  	that.dinnerData[1].lunch = data.Tuesday_lunch;
		                  	that.dinnerData[1].dinner = data.Tuesday_dinner;
		                  	that.dinnerData[2].breakfast = data.Wednesday_breakfast;
		                  	that.dinnerData[2].lunch = data.Wednesday_lunch;
		                  	that.dinnerData[2].dinner = data.Wednesday_dinner;
		                  	that.dinnerData[3].breakfast = data.Thursday_breakfast;
		                  	that.dinnerData[3].lunch = data.Thursday_lunch;
		                  	that.dinnerData[3].dinner = data.Thursday_dinner;
		                  	that.dinnerData[4].breakfast = data.Friday_breakfast;
		                  	that.dinnerData[4].lunch = data.Friday_lunch;
		                  	that.dinnerData[4].dinner = data.Friday_dinner;
//                      	var deleteNum = 0;
//                      	var len = res.data.result.result.length - 1;
//                      	if(res.data.result.result[len].breakfast == "无" && res.data.result.result[len].lunch == "无"){
//                      		res.data.result.result.pop();
//                      		deleteNum++;
//                      	}
//                      	if(res.data.result.result[len-1].breakfast == "无" && res.data.result.result[len-1].lunch == "无"){
//                      		res.data.result.result.pop();
//                      		deleteNum++;
//                      	}
//                      	for(var j=0;j<deleteNum;j++){
//                      		that.dinnerData.pop();
//                      	}
//                          for(var j=0;j<that.dinnerData.length;j++){
//                              that.dinnerData[j].breakfast = res.data.result.result[j].breakfast;
//                              that.dinnerData[j].lunch = res.data.result.result[j].lunch;
//                          }
                        }
                    }
                    this.ajaxPostWX(params)
                }
            },
            changIt(e) {
                //添加判断path对象是否存在逻辑
                var ele = e.path ? e.path[0] : e.target;
                var username = ele.getAttribute("id");
                if(ele.classList[0] == "true"){
                    // ele.classList.remove("true");
                    // ele.classList.add("wait");
                    this.changeState(username,"wait");
                }else if(ele.classList[0] == "wait"){
                    // ele.classList.remove("wait");
                    // ele.classList.add("false");
                    this.changeState(username,"delete");
                }else if(ele.classList[0] == "false"){
                    // ele.classList.remove("false");
                    // ele.classList.add("true");
                    this.changeState(username,"add");
                }
            },
            //改变状态
            changeState(name,state){
                if(this.dateState == "今天"){
                    var time = this.diyitian.format("yyyy-MM-dd");
                }else if(this.dateState == "明天"){
                    var time = new Date(this.diertian.getTime()).format("yyyy-MM-dd");
                }else if(this.dateState == "后天"){
                    var time = new Date(this.disantian.getTime()).format("yyyy-MM-dd");
                }else if(this.dateState=="第四天"){
                  var time = new Date(this.disitian.getTime()).format("yyyy-MM-dd");
                }else if(this.dateState=="第五天"){
                  var time = new Date(this.diwutian.getTime()).format("yyyy-MM-dd");
                }
                console.log(time);
                var that = this;
                let params = {};
                params.url = "/sys/mealrecord/usereditinfo";
                params.token = "swgykj9527";
                params.data = {
                    "username" : name,
                    "meal_date" : time,
                    "meal_type":that.shiduan,
                    "edit_type": state
                },
                console.log(params.data);
                params.success=function(res){
                    if(res.data.code = "0000"){
                        that.$Message.success({
                            content: res.data.message
                        });
                        setTimeout(() => {
                          if(that.dateState == "今天"&& that.lunchState == "早餐"){
                            that.getleftData(0,0);
                          }else if(that.dateState == "今天"&& that.lunchState == "午餐"){
                            that.getleftData(0,1);
                          }else if(that.dateState == "今天"&& that.lunchState == "晚餐"){
                            that.getleftData(0,2);
                          }else if(that.dateState == "明天"&& that.lunchState == "早餐"){
                            that.getleftData(1,3);
                          }else if(that.dateState == "明天"&& that.lunchState == "午餐"){
                            that.getleftData(1,4);
                          }else if(that.dateState == "明天"&& that.lunchState == "晚餐"){
                            that.getleftData(1,5);
                          }else if(that.dateState == "后天"&& that.lunchState == "早餐"){
                            that.getleftData(2,6);
                          }else if(that.dateState == "后天"&& that.lunchState == "午餐"){
                            that.getleftData(2,7);
                          }else if(that.dateState == "后天"&& that.lunchState == "晚餐"){
                            that.getleftData(2,8);
                          }else if(that.dateState == "第四天"&& that.lunchState == "早餐"){
                            that.getleftData(3,9);
                          }else if(that.dateState == "第四天"&& that.lunchState == "午餐"){
                            that.getleftData(3,10);
                          }else if(that.dateState == "第四天"&& that.lunchState == "晚餐"){
                            that.getleftData(3,11);
                          }else if(that.dateState == "第五天"&& that.lunchState == "早餐"){
                            that.getleftData(4,12);
                          }else if(that.dateState == "第五天"&& that.lunchState == "午餐"){
                            that.getleftData(4,13);
                          }else if(that.dateState == "第五天"&& that.lunchState == "晚餐"){
                            that.getleftData(4,14);
                          }
//                            if(that.dateState == "今天"&& that.lunchState == "早餐"){
//                                that.getleftData(0,0);
//                            }else if(that.dateState == "今天"&& that.lunchState == "午餐"){
//                                that.getleftData(0,1);
//                            }else if(that.dateState == "明天"&& that.lunchState == "早餐"){
//                                that.getleftData(1,2);
//                            }else if(that.dateState == "明天"&& that.lunchState == "午餐"){
//                                that.getleftData(1,3);
//                            }else if(that.dateState == "后天"&& that.lunchState == "早餐"){
//                                that.getleftData(2,4);
//                            }else if(that.dateState == "后天"&& that.lunchState == "午餐"){
//                                that.getleftData(2,5);
//                            }else if(that.dateState == "第四天"&& that.lunchState == "早餐"){
//                              that.getleftData(3,6);
//                            }else if(that.dateState == "第四天"&& that.lunchState == "午餐"){
//                              that.getleftData(3,7);
//                            }else if(that.dateState == "第五天"&& that.lunchState == "早餐"){
//                              that.getleftData(4,8);
//                            }else if(that.dateState == "第五天"&& that.lunchState == "午餐"){
//                              that.getleftData(4,9);
//                            }
                        }, 100);
                    }else{
                        that.$Message.warning({
                            content: res.data.message
                        });
                    }
                    that.showIt = res.data;
                };
                that.ajaxPostWX(params);
            },
            toNext(){
                this.swiper.slideTo(this.swiper.activeIndex+1);
            },
            toPre(){
                this.swiper.slideTo(this.swiper.activeIndex-1);
            },
            swiperCan(){
                var that = this;
                that.activeIndex = that.swiper.activeIndex;
                that.pageNum = that.swiper.slides.length
                this.swiper.on("slideChangeTransitionStart",function(){
                    that.activeIndex = that.swiper.activeIndex;
                })
                this.$nextTick(() => {
                	this.zc()
                })
            },
            getSwiperData(id){
                var that = this;
                let params = {};
                params.url = "/manage/messagelist/list";
                params.data = {
                    searchValue: {
                        "id" : id
                    }
                }
                params.token = "swgykj9527";
                params.success=function(res){
//                  if(res.data.result.result.length > 2){
//                      that.swiperData.unshift(res.data.result.result[0]);
//                  }else{
//                      that.swiperData.pop();
//                      that.swiperData.unshift(res.data.result.result[0]);
//                  }
					that.swiperData = [];
                    for(var i=0;i<res.data.result.result.length;i++){
//                      if(i<3){
                        that.swiperData.push(res.data.result.result[i])
//                      }
                    }
                    setTimeout(() => {
                        that.swiperCan();
                    }, 200);
                };
                that.ajaxPostWX(params);
            },
            getSwiperArr(){
                var that = this;
                let params = {};
                params.url = "/manage/messagelist/list";
                params.data = {
                    searchValue: {
//                      "type" : "simple",
                        "status" : true
                    },
                    orderValue: {
                        "_id":"-1"
                    }
                }
                params.token = "swgykj9527";
                params.success=function(res){
                console.log("================",res.data.result.result);
                    that.swiperData = [];
                    for(var i=0;i<res.data.result.result.length;i++){
//                      if(i<3){
                        that.swiperData.push(res.data.result.result[i])
//                      }
                 }
                    setTimeout(() => {
                        that.swiperCan();
                    }, 200);
                };
                that.ajaxPostWX(params);
            },
            getleftData(e,m) {
                if(!m){
                    m=0;
                }
                this.getLocked();
                var that = this;
                var ele = document.getElementsByClassName("allItBtn");
                let params = {};
                for(var i =0;i<ele.length;i++){
                    ele[i].classList.remove("changBtm");
                }
                ele[m].classList.add("changBtm");
                if(m==0){
                    this.curDay = this.diyitian.format("yyyy-MM-dd");
                    this.theTopTime = this.diyitian.format("MM月dd日");
                    this.curLunch = "breakfast";
                }else if(m==1){
                    this.theTopTime = this.diyitian.format("MM月dd日");
                    this.curDay = this.diyitian.format("yyyy-MM-dd");
                    this.curLunch = "lunch";
                }else if(m==2){
                  this.theTopTime = this.diyitian.format("MM月dd日");
                  this.curDay = this.diyitian.format("yyyy-MM-dd");
                  this.curLunch = "dinner";
                }else if(m==3){
                    this.theTopTime = new Date(this.diertian.getTime()).format("MM月dd日");
                    this.curDay = new Date(this.diertian.getTime()).format("yyyy-MM-dd");
                    this.curLunch = "breakfast";
                }else if(m==4){
                    this.theTopTime = new Date(this.diertian.getTime()).format("MM月dd日");
                    this.curDay = new Date(this.diertian.getTime()).format("yyyy-MM-dd");
                    this.curLunch = "lunch";
                }else if(m==5){
                  this.theTopTime = new Date(this.diertian.getTime()).format("MM月dd日");
                  this.curDay = new Date(this.diertian.getTime()).format("yyyy-MM-dd");
                  this.curLunch = "dinner";
                }else if(m==6){
                  this.theTopTime = new Date(this.disantian.getTime()).format("MM月dd日");
                    this.curDay = new Date(this.disantian.getTime()).format("yyyy-MM-dd");
                    this.curLunch = "breakfast";
                }else if(m==7){
                    this.theTopTime = new Date(this.disantian.getTime()).format("MM月dd日");
                    this.curDay = new Date(this.disantian.getTime()).format("yyyy-MM-dd");
                    this.curLunch = "lunch";
                }else if(m==8){
                  this.theTopTime = new Date(this.disantian.getTime()).format("MM月dd日");
                  this.curDay = new Date(this.disantian.getTime()).format("yyyy-MM-dd");
                  this.curLunch = "dinner";
                }else if(m==9){
                  this.theTopTime = new Date(this.disitian.getTime()).format("MM月dd日");
                  this.curDay = new Date(this.disitian.getTime()).format("yyyy-MM-dd");
                  this.curLunch = "breakfast";
                }else if(m==10){
                  this.theTopTime = new Date(this.disitian.getTime()).format("MM月dd日");
                  this.curDay = new Date(this.disitian.getTime()).format("yyyy-MM-dd");
                  this.curLunch = "lunch";
                }else if(m==11){
                  this.theTopTime = new Date(this.disitian.getTime()).format("MM月dd日");
                  this.curDay = new Date(this.disitian.getTime()).format("yyyy-MM-dd");
                  this.curLunch = "dinner";
                }else if(m==12){
                  this.theTopTime = new Date(this.diwutian.getTime()).format("MM月dd日");
                  this.curDay = new Date(this.diwutian.getTime()).format("yyyy-MM-dd");
                  this.curLunch = "breakfast";
                }else if(m==13){
                  this.theTopTime = new Date(this.diwutian.getTime()).format("MM月dd日");
                  this.curDay = new Date(this.diwutian.getTime()).format("yyyy-MM-dd");
                  this.curLunch = "lunch";
                }else if(m==14){
                  this.theTopTime = new Date(this.diwutian.getTime()).format("MM月dd日");
                  this.curDay = new Date(this.diwutian.getTime()).format("yyyy-MM-dd");
                  this.curLunch = "dinner";
                }
                if(m==0){
                    this.dateState = "今天";
                    this.lunchState = "早餐";
                }else if(m==1){
                    this.dateState = "今天";
                    this.lunchState = "午餐";
                }else if(m==2){
                  this.dateState = "今天";
                  this.lunchState = "晚餐";
                }else if(m==3){
                    this.dateState = "明天";
                    this.lunchState = "早餐";
                }else if(m==4){
                    this.dateState = "明天";
                    this.lunchState = "午餐";
                }else if(m==5){
                  this.dateState = "明天";
                  this.lunchState = "晚餐";
                }else if(m==6){
                    this.dateState = "后天";
                    this.lunchState = "早餐";
                }else if(m==7){
                    this.dateState = "后天";
                    this.lunchState = "午餐";
                }else if(m==8){
                  this.dateState = "后天";
                  this.lunchState = "晚餐";
                }else if(m==9){
                  this.dateState = "第四天";
                  this.lunchState = "早餐";
                }else if(m==10){
                  this.dateState = "第四天";
                  this.lunchState = "午餐";
                }else if(m==11){
                  this.dateState = "第四天";
                  this.lunchState = "晚餐";
                }else if(m==12){
                  this.dateState = "第五天";
                  this.lunchState = "早餐";
                }else if(m==13){
                  this.dateState = "第五天";
                  this.lunchState = "午餐";
                }else if(m==14){
                  this.dateState = "第五天";
                  this.lunchState = "晚餐";
                }
              params.url = "/sys/mealrecord/windowshow";
              params.data = {
                meal_date: this.curDay,
                meal_type: this.curLunch
              };
                params.token = "swgykj9527";
                params.success=function(res){
                    that.peopleList = res.data.result.user_meal;
                    that.bcNum = res.data.result.meal_count;
                    that.inertvelTime = res.data.result.meal_end_time;
                    that.recviceStr = res.data.result.meal_entertain;
                    that.shiduan = res.data.result.meal_type;
            		that.recivce();
                };
                that.ajaxPostWX(params);
            },
            getBG(){
                var that = this;
                let params = {};
                params.url = "/sys/bookmealsetting/list";
                params.token = "swgykj9527";
                params.success=function(res){
                	console.log("lksajdlksa",res.data);
                    var ele = document.getElementsByClassName("bigScreen")[0];
                    var imgSrc = parameters.domain+res.data.result.result[0].image_path;
                    ele.style.backgroundImage = "url("+imgSrc+")";
                    ele.style.backgroundSize = "cover";
                };
                that.ajaxPostWX(params);
            },
            socket(){
                // const options = {
                //     connectionTimeout :1000 ,
                //     connectionTimeout: 2000,
                //     maxRetries :1000000 ,
                // } ;
                // const websocket = new ReconnectingWebSocket(parameters.domain3+"/wtshuiwen/newinfo/user1",[],options);
                // websocket.addEventListener('open', () => {
                //     console.log("dkjsaljd");
                // });
                // websocket.addEventListener('open', () => {
                //     console.log("成功打开");
                // });
                // websocket.addEventListener('error', () => {
                //     console.log("错误");
                // });
                // websocket.addEventListener('message', (event) => {
                //     var that = this;
                //     var socketDate = JSON.parse(event.data)
                //     if(socketDate.type == "meal"){
                //         console.log("gaibian");
                //         if(that.dateState == "今天"&& that.lunchState == "早餐"){
                //             that.getleftData(0,0);
                //         }else if(that.dateState == "今天"&& that.lunchState == "午餐"){
                //             that.getleftData(0,1);
                //         }else if(that.dateState == "明天"&& that.lunchState == "早餐"){
                //             that.getleftData(1,2);
                //         }else if(that.dateState == "明天"&& that.lunchState == "午餐"){
                //             that.getleftData(1,3);
                //         }else if(that.dateState == "后天"&& that.lunchState == "早餐"){
                //             that.getleftData(2,4);
                //         }else if(that.dateState == "后天"&& that.lunchState == "午餐"){
                //             that.getleftData(2,5);
                //         }
                //     }else if(socketDate.type == "message"){
                //     	this.getSwiperArr();
                //     }else if(socketDate.type == "bg_image"){
                //         this.getBG();
                //     }else if(socketDate.type == "flushWindows"){
                //         window.location.reload();
                //     }
                // });

                window.clearInterval(this.socketTimer);
                var randomNum = Math.ceil(Math.random()*9999);
                console.log(randomNum);
                this.websocket  = new WebSocket(parameters.domain3+"/wtshuiwen/newinfo/user2");
                this.websocket.onopen = function (e) {
                    console.log("=====================------ssss")
                };
                this.websocket.onerror = function (e) {
                    console.log('WebSocket发生错误: ' + e.code)
                    console.log(e)
                }
                this.websocket.onmessage = (event) => {
                    var that = this;
                    var socketDate = JSON.parse(event.data);
                    if(JSON.parse(event.data).type == "meal"){
                        console.log("gaibian");
                        if(that.dateState == "今天"&& that.lunchState == "早餐"){
                            that.getleftData(0,0);
                        }else if(that.dateState == "今天"&& that.lunchState == "午餐"){
                            that.getleftData(0,1);
                        }else if(that.dateState == "今天"&& that.lunchState == "晚餐"){
                          that.getleftData(0,2);
                        }else if(that.dateState == "明天"&& that.lunchState == "早餐"){
                            that.getleftData(1,3);
                        }else if(that.dateState == "明天"&& that.lunchState == "午餐"){
                            that.getleftData(1,4);
                        }else if(that.dateState == "明天"&& that.lunchState == "晚餐"){
                          that.getleftData(1,5);
                        }else if(that.dateState == "后天"&& that.lunchState == "早餐"){
                            that.getleftData(2,6);
                        }else if(that.dateState == "后天"&& that.lunchState == "午餐"){
                            that.getleftData(2,7);
                        }else if(that.dateState == "后天"&& that.lunchState == "晚餐"){
                          that.getleftData(2,8);
                        }else if(that.dateState == "第四天"&& that.lunchState == "早餐"){
                          that.getleftData(3,9);
                        }else if(that.dateState == "第四天"&& that.lunchState == "午餐"){
                          that.getleftData(3,10);
                        }else if(that.dateState == "第四天"&& that.lunchState == "晚餐"){
                          that.getleftData(3,11);
                        }else if(that.dateState == "第五天"&& that.lunchState == "早餐"){
                          that.getleftData(4,12);
                        }else if(that.dateState == "第五天"&& that.lunchState == "午餐"){
                          that.getleftData(4,13);
                        }else if(that.dateState == "第五天"&& that.lunchState == "晚餐"){
                          that.getleftData(4,14);
                        }
                    }else if(socketDate.type == "message"){
                    	this.getSwiperArr();
                    }else if(socketDate.type == "bg_image"){
                        this.getBG();
                        this.searchDate();
                    }else if(socketDate.type == "flushWindows"){
                        window.location.reload();
                    }else if(socketDate.type == "@heart"){
                        this.socketOK = "getIt";
                        console.log("收到");
                      if(that.dateState == "今天"&& that.lunchState == "早餐"){
                        that.getleftData(0,0);
                      }else if(that.dateState == "今天"&& that.lunchState == "午餐"){
                        that.getleftData(0,1);
                      }else if(that.dateState == "今天"&& that.lunchState == "晚餐"){
                        that.getleftData(0,2);
                      }else if(that.dateState == "明天"&& that.lunchState == "早餐"){
                        that.getleftData(1,3);
                      }else if(that.dateState == "明天"&& that.lunchState == "午餐"){
                        that.getleftData(1,4);
                      }else if(that.dateState == "明天"&& that.lunchState == "晚餐"){
                        that.getleftData(1,5);
                      }else if(that.dateState == "后天"&& that.lunchState == "早餐"){
                        that.getleftData(2,6);
                      }else if(that.dateState == "后天"&& that.lunchState == "午餐"){
                        that.getleftData(2,7);
                      }else if(that.dateState == "后天"&& that.lunchState == "晚餐"){
                        that.getleftData(2,8);
                      }else if(that.dateState == "第四天"&& that.lunchState == "早餐"){
                        that.getleftData(3,9);
                      }else if(that.dateState == "第四天"&& that.lunchState == "午餐"){
                        that.getleftData(3,10);
                      }else if(that.dateState == "第四天"&& that.lunchState == "晚餐"){
                        that.getleftData(3,11);
                      }else if(that.dateState == "第五天"&& that.lunchState == "早餐"){
                        that.getleftData(4,12);
                      }else if(that.dateState == "第五天"&& that.lunchState == "午餐"){
                        that.getleftData(4,13);
                      }else if(that.dateState == "第五天"&& that.lunchState == "晚餐"){
                        that.getleftData(4,14);
                      }
                    }
                };
                this.setSocketTimer();
            },
            setSocketTimer(){
                this.socketTimer = setInterval(()=>{
                    if(this.socketOK == "getIt"){
                        this.socketOK = "notGet";
                        console.log("在链接");
                    }else{
                        console.log("断开了重连");
                        this.websocket.close();
                        this.socket();
                    }
                },1000*60)
                // setTimeout(() => {
                //     this.websocket.close();
                //     console.log("guanbile")
                // }, 10000);
            },
            getDate(){
                var now = new Date;
                var day = now.getDay ();
                var week = "1234560";
                var first = 0 - week.indexOf (day);
                var f = new Date;
                f.setDate (f.getDate () + first);
                var last = 6 - week.indexOf (day);
                var l = new Date;
                l.setDate (l.getDate () + last);
                return [
                        f, l
                ];
            },
            //获取秒数
            getSecond(){
                var that = this;
                let params = {};
                params.url = "/sys/bookmealsetting/list";
                params.token = "swgykj9527";
                params.success=function(res){
                    that.second = res.data.result.result[0].close_time;
                    if(that.second == 0){
                        that.maxSecond = false;
                        that.second = 60*60*24*30;
                    }
                };
                that.ajaxPostWX(params);
            },
            //计时器
            setInter(){
                var i = 0;
            	setInterval(()=>{
            		var zhongwu = new Date().format("hh");
            		var zhongwu2 = new Date().format("mm");
            		var zhongwu3 = new Date().format("ss");
                    // console.log(parseInt(zhongwu),parseInt(zhongwu2),parseInt(zhongwu3));
            		if(parseInt(zhongwu) == 9 &&  parseInt(zhongwu2)==0 && parseInt(zhongwu3) == 0){
                        window.location.reload();
            		}else if(parseInt(zhongwu) == 14 &&  parseInt(zhongwu2)==0 && parseInt(zhongwu3) == 0){
                        window.location.reload();
            		}else if(parseInt(zhongwu) == 0 && parseInt(zhongwu2)==2 && parseInt(zhongwu3) == 0){
                        window.location.reload();
                    }else if(parseInt(zhongwu) == 1 && parseInt(zhongwu2)==2 && parseInt(zhongwu3) == 0){
                        window.location.reload();
                    }else if(parseInt(zhongwu) == 3 && parseInt(zhongwu2)==2 && parseInt(zhongwu3) == 0){
                        window.location.reload();
                    }
            	},400)
            },
            getLocked(){

                var that = this;
                let params = {};
                params.url = "/sys/bookmealsetting/list";
                params.token = "swgykj9527";
                params.success=function(res){
                    if(new Date().format("hh:mm")>res.data.result.result[0].change_time){
                        that.lockEdTime = new Date(new Date().getTime()+(1000*60*60*24));
                    }else{
                        that.lockEdTime = new Date(new Date().getTime());
                    }
                };
                that.ajaxPostWX(params);

            },
            getTitleStr(){
            	var that = this;
            	var zhongwu = new Date().format("hh");
            	if(zhongwu>9 && zhongwu<14){
            		var curDate = new Date();
        			var nextDate = new Date(curDate.getTime()).format("MM") + "月"+ new Date(curDate.getTime()).format("dd")+"日";
        			that.titleStr = "午餐";
            	}else{
            		var curDate = new Date();
        			var nextDate = new Date(curDate.getTime() + 24*60*60*1000).format("MM") + "月"+ new Date(curDate.getTime() + 24*60*60*1000).format("dd")+"日";
        			that.titleStr = "早餐";
            	}
            },
            getFirst(){
                if(new Date().format("yyyy-MM-dd")< this.diyitian.format("yyyy-MM-dd")){
                    this.getleftData(0,0);
                    this.dateState == "今天"
                }else if(parseInt(new Date().format("hh"))>=9 && parseInt(new Date().format("hh"))<13){
                    this.getleftData(0,1);
                    this.dateState == "今天"
                }else if(parseInt(new Date().format("hh"))<9){
                    this.getleftData(0,0);
                    this.dateState == "今天"
                }else{
                    this.getleftData(1,2);
                    this.dateState == "明天"
                }
            },
            getTwoDay(){
                var that = this;
                let params = {};
                params.url = "/sys/mealrecord/workdate";
                params.token = "swgykj9527";
                params.success=function(res){
                	console.log("dkajskdas",res);
                    var firstTime = res.data.result[0].split("-");
                    var secondTime = res.data.result[1].split("-");
                    var thirdTime = res.data.result[2].split("-");
                    var fourthTime = res.data.result[3].split("-");
                    var fifthTime = res.data.result[4].split("-");
                    that.diyitian = new Date(firstTime[0],firstTime[1]-1,firstTime[2]);
                    that.diertian = new Date(secondTime[0],secondTime[1]-1,secondTime[2]);
                    that.disantian = new Date(thirdTime[0],thirdTime[1]-1,thirdTime[2]);
                    that.disitian = new Date(fourthTime[0],fourthTime[1]-1,fourthTime[2]);
                    that.diwutian = new Date(fifthTime[0],fifthTime[1]-1,fifthTime[2]);
                    that.getLocked();
                    that.getSwiperArr();
                    that.swiperCan();
                    that.getleftData();
                    that.getSecond();
                    that.socket();
                    that.getBG();
                    that.getTitleStr();
                    that.setInter();
                    that.getFirst();
                };
                that.ajaxPostWX(params);
            }
        },
        computed: {
        	swiper() {
		        return this.$refs.mySwiper.swiper
		    }
        },
        mounted: function() {
          var video = document.getElementsByTagName("video");
        	this.$refs.mySwiper.swiper.on('slideChangeTransitionEnd',function(){
        		for(var i=0;i<video.length;i++){
        			video[i].pause();
        		}
        	})
            this.getTwoDay();
            this.setThreePartScroll()
            window.setTimeout(() => {
            	this.isKaishi = true
            	this.numP = 1
            }, 500)
//          this.getDigui();
        }
    }



</script>
<style lang="scss">
    @import "../../global/css/swiper.scss";
    .menuTd{
        display: inline-block;
        white-space: nowrap;
        border: 1px solid #ededed;
        overflow: hidden;
        >div{
            display: inline-block;
            width: auto;
        }
    }
    .scrollLeft>div{
    	padding-left: 70px;
        animation: scrLeft 6s linear infinite;
    }
    @keyframes scrLeft {
        from{
            margin-left: 0;
        }
        to{
            margin-left: -100%;
        }
    }
    .btnSet2{
    	width: 140px;
    	height: 50px;
    	border-radius: 8px;
    	font-size: 24px;
    	color: #fff;
    	float: left;
    	text-align: center;
    	background: #45AAF9;
    	line-height: 50px;
    }
    .animationGo{
    	// animation: mymove 10s linear;
    	// animation-iteration-count: infinite;
    }
    @keyframes mymove
	{
		from {margin-top:30px;}
		to {margin-top:-100%;}
	}
    .modelBig{
    	.ivu-modal{
    		width: 90% !important;
    		/*top: 60px;*/
    		top: 20px;
    	}
    	.ivu-modal-content{
    		background: rgba(249,249,249,.8);
    		border-radius: 35px;
    	}
    	.ivu-modal-header-inner{
    		font-size: 36px;
    		color: #45AAF9;
    		text-align: center;
    		height: 50px;
    		line-height: 50px;
    	}
    	.ivu-modal-close{
    		display: none;
    	}
    	.ivu-modal-header{
    		border-bottom:  0;
    	}
    	.ivu-modal-body{
    		padding: 0;
    	}
    	.ivu-modal-footer{
    		text-align: center;
    		button:first-child{
    			display: none;
    		}
    		button{
    			width: 210px;
    			height: 65px;
    			font-size: 28px;
    			border: 8px;
    		}
    	}
    }
    .bigScreenTab{
        overflow-y: scroll;
        overflow-x: hidden;
        text-align: center;
        border-top: 0;
        border-color: #ededed;
        margin: 0 auto;
        font-size: 32px;
    	color: #474444;
        border: 0;
        td{
            width: 300px;
            word-break: break-all;
            height: 50px;
            input{
                height: 100%;
                width: 100%;
                border: 0;
                height: 100%;
                padding: 5px;
                width: 100%;
                display: inline-block;
            }
        }
        td:last-child{
        	width: 1100px;
        }
    }
    .bigScreenTab:first-child{
        border-top: 1px solid #ededed;
    }
    .bigScreen .swiper-container img{
    	width: 100%;
    	max-height: 300px !important;
    	object-fit: contain;
    }
    .bigScreen3 .swiper-container img{
    	width: 100%;
    	max-height: 700px !important;
    	object-fit: contain;
    }
    .bigScreen .swiper-container .rightConL{
    	padding: 0 30px;
    }
    .bigScreen .swiper-container .rightConL .swiper-container{
    	line-height: 800px;
	    display: inline-block;
	    width: 100%;
	    height: 100%;

    }
    .bigScreen .swiper-container .rightConL img{
    	height: 100%;
    	max-height: 100%;
    }
.bigScreen{
    overflow: hidden;
    .marginBig{
    	margin-top: 100px !important;
    	margin-bottom: 200px !important;
    }
    .autoHeight{
    	height: auto !important;
    }
    .ql-editor .ql-indent-8:not(.ql-direction-rtl){
    	padding-left: 8em;
    }
    .ql-editor .ql-indent-7:not(.ql-direction-rtl){
    	padding-left: 7em;
    }
    .ql-editor .ql-indent-6:not(.ql-direction-rtl){
    	padding-left: 6em;
    }
    .ql-editor .ql-indent-5:not(.ql-direction-rtl){
    	padding-left: 5em;
    }
    .ql-editor .ql-indent-4:not(.ql-direction-rtl){
    	padding-left: 4em;
    }
    .ql-editor .ql-indent-3:not(.ql-direction-rtl){
    	padding-left: 3em;
    }
    .ql-editor .ql-indent-2:not(.ql-direction-rtl){
    	padding-left: 2em;
    }
    .ql-editor .ql-indent-1:not(.ql-direction-rtl){
    	padding-left: 1em;
    }
    .index_vue .flowIndex_right{
        width: 1920px;
        height: 1080px;
        box-sizing: border-box;
    }
    .smallIt{
    	overflow: hidden;
    	margin-top: 50px;
    	position: absolute;
    	left: 30px;
    	top: 358px;
    	float: right;
    	width: 100%;
    	height: 436px;
        >div{
            position: absolute;
            z-index: 99;
        }
    }
    .ql-editor img{
    	max-width: 100%;
    }
    .bigIt{
    	overflow-y: scroll;
    	margin-top: 50px;
    	position: absolute;
    	left: auto;
    	right: 30px;
    	top: 68px;
    	float: right;
    	width: 51%;
    	height: 650px;
    }
    .is100{
    	height: 100% !important;
		width: 100% !important;
    }
    .bottomBtn{
        text-align: center;
        position: relative;
        padding-top: 16px;
        .bottomLeft{
            position: absolute;
            height: 100%;
            line-height: 88px;
            right: 0;
            top: 0;
            font-size: 30px;
            color: #fff;
            text-indent: 100px;
            background-image: url("../../assets/bigScreen/btmLeft.png");
            background-repeat: no-repeat;
            background-position: left center;
            background-size: 80px 80px;
        }
        .bottomRight{
            position: absolute;
            height: 100%;
            right: 50px;
            top: 0;
            width: 300px;
            // background-image: url("../../assets/bigScreen/btmRight.png");
            background-repeat: no-repeat;
            background-position: right center;
        }
        span{
            padding: 0 50px;
            display: inline-block;
            font-size: 20px;
            color: #7c7c7c;
            height: 45px;
            font-weight: bold;
            line-height: 117px;
            width: 200px;
        }
        .toBlue{
            color: #45aaf9
        }
        span:nth-child(3){
            background: url("../../assets/bigScreen/icon1.png") no-repeat top center;
        }
        span:nth-child(4){
            background: url("../../assets/bigScreen/icon2.png") no-repeat top center;
        }
        span:nth-child(5){
            background: url("../../assets/bigScreen/icon3.png") no-repeat top center;
        }
        .toBlue:nth-child(3){
            background: url("../../assets/bigScreen/iconB1.png") no-repeat top center;
        }
        .toBlue:nth-child(4){
            background: url("../../assets/bigScreen/iconB2.png") no-repeat top center;
        }
        .toBlue:nth-child(5){
            background: url("../../assets/bigScreen/iconB3.png") no-repeat top center;
        }
    }
}
    .bigScreen{
        height: 1080px;
        width: 1920px;
        font-weight: bold;
        background-repeat: no-repeat;
        background-size: contain;
        padding: 60px 58px 0 58px;
        .swiper-pagination{
            opacity: 0;
        }
        .rightCon{
            height: 100%;
            width: calc(50% - 28px);
            float: right;
            background: #fff;
            border-radius: 35px;
            opacity: .8;
            h4{
                font-size: 33px;
                font-weight: bolder;
                color: #474444;
                border: none;
                display: none;
            }
            .rightBottom{
            	padding-top: 30px;
                font-size: 24px;
                color: #474444;
            }
        }
        .btmLeft{
            float: left;
            font-size: 24px;
            padding-left: 56px;
            padding-top: 25px;
            color: #474747;
            .btmToday{
                float: left;
                width: 116px;
                line-height: 80px;
                columns: #000;
                height: 80px;
                text-align: center;
                border-radius: 10px;
                font-size: 17px;
                font-weight: bold;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                border: 2px solid #000;
            }
            .btmAshita{
                float: left;
                width: 116px;
                columns: #000;
                border-radius: 10px;
                font-size: 18px;
                text-align: center;
                line-height: 80px;
                font-weight: bold;
                border: 2px solid #000;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                border-left: 0;
                height: 80px;
            }
            .allItBtn:nth-child(2),.allItBtn:nth-child(3),.allItBtn:nth-child(4),.allItBtn:nth-child(5),.allItBtn:nth-child(6),.allItBtn:nth-child(7),.allItBtn:nth-child(8),.allItBtn:nth-child(9),.allItBtn:nth-child(10),.allItBtn:nth-child(11),.allItBtn:nth-child(12),.allItBtn:nth-child(13),.allItBtn:nth-child(14){
                border-radius: 0;
                border-left: 0;
            }
            .changBtm{
                background: #45AAF9;
                color: #fff
            }
            p{
                line-height: 50px;
                span{
                    height: 25px;
                    width: 25px;
                    border-radius: 4px;
                    display: inline-block;
                    margin-right: 30px;
                    background: #1874ef;
                }
            }
            p:nth-child(2) span{
                background: #ff9f25;
            }
            p:nth-child(3) span{
                background: #e22018;
            }
        }
        .btmRight{
            float: right;
            padding-left: 56px;
            font-size: 24px;
            text-align: right;
            color: #474747;
            max-width: 657px;
            white-space: nowrap;
            height: 205px;
            overflow: hidden;
            margin-bottom: 10px;
            padding-top: 15px;
            .bcClass{
                font-size: 28px;
                line-height: 40px;
                height: 40px;
                color: #474444;
                span{
                    font-weight: bold;
                }
            }
            .recivce{
                font-size: 28px;
                color: #474444;
                /*height: 50px;*/
                position: relative;
                padding-right: 30px;
                line-height: 40px;
            }
            button{
            	display: inline-block;
            	width: 140px;
            	height: 50px;
            	font-size: 24px;
            	color: #45AAF9;
            	color: #fff;
            	margin-right: 0;
            }
        }
        .leftCon{
            background: #fff;
            border-radius: 35px;
            opacity: .8;
            height: 100%;
            width: calc(50% - 28px);
            float: left;
        }
        h4{
            text-align: center;
            font-size: 33px;
            color: #45aaf9;
            padding-bottom: 20px;
            font-weight: bolder;
            padding-top: 35px;
            width: 760px;
            margin: 0 auto;
            border-bottom: 1px solid #d1d1d1;
        }
        .leftBg{
            /*height: 610px;*/
            height: 610px;
            padding: 0 54px;
            padding-top: 15px;
            >span{
                float: left;
                text-align: center;
                font-size: 36px;
                color: #fff;
                position: relative;
                overflow: hidden;
                height: 65px;
                min-width: 130px;
                line-height: 65px;
                border-radius: 8px;
                margin-left: 26px;
                margin-bottom: 15px;
            }
            .haveBr{
            	font-size: 22px;
			    word-spacing: normal;
			    line-height: 32px;
            }
            span:nth-child(5n-4){
                margin-left: 0;
            }
            .true{
                background: #1874ef;
            }
            .wait{
                background: #ff9f25;
            }
            .false{
                background: #e22018;
            }
            .recive{
                width: 100%;
                padding: 0 30px;
                height: 50px;
                float: left;
                line-height: 50px;
                font-size: 20px;
                color: #fff;
            }
        }
        .bcClass{
            padding: 10px 30px;
            font-size: 32px;
            font-weight: bold;
            color: #000;
        }
    }
    .bigScreen2{
        h4{
            width: 94%;
        }
        .leftBg{
            >span{
                min-width: 146px;
                height: 68px;
                line-height: 68px;
                margin-left: 24px;
                margin-bottom: 18px;
            }
            >span:nth-child(5n-4){
                margin-left: 24px;
            }
            >span:nth-child(10n-9){
                margin-left: 0;
            }
            .haveBr{
            	font-size: 22px;
			    word-spacing: normal;
			    line-height: 40px;
            }
        }
        .leftCon{
            width: 100%;
        }
        .btmLeft p{
            float: left;
            margin-right: 50px;
        }
    }
    .bigScreen{
    	.rightCon{
    		.swiper-pagination{
    			img{
    				max-height: 300px !important;
    				object-fit: contain;
    			}
    		}
    	}
    }
    .bigScreen3{
        .rightCon{
            width: 100%;
            padding-top: 38px;
            .swiper-pagination{
                width: 1000px;
                opacity: 1;
                margin: 0 auto;
                position: relative;
                text-align: center;
                span{
                    height: 15px;
                    width: 15px;
                    background: #706767;
                    display: inline-block;
                    margin: 0 12px;
                    border-radius: 50%;

                }
                img{
    				max-height: 100% !important;
    				object-fit: contain;
    			}
            }
            h4{
                display: none;
            }
            h2{
                font-size: 58px;
            }
            .rightConL{
                width: 48%;
                float: left;
                overflow: hidden;
                height: 88%;
            }
            .rightConR{
                width: 95%;
                float: right;
            }
        }
    }
    .nui-scroll2::-webkit-scrollbar {
	    width: 8px;//表示垂直滚动条的宽度
	    height: 8px;//表示水平滚动条的高度
	}
	/*正常情况下滑块的样式*/
	.nui-scroll2::-webkit-scrollbar-thumb {
	    background-color: rgba(0,0,0,.05);
	    border-radius: 10px;
	    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
	}
	/*鼠标悬浮在该类指向的控件上时滑块的样式*/
	.nui-scroll2:hover::-webkit-scrollbar-thumb {
	    background-color: rgba(0,0,0,.2);
	    border-radius: 10px;
	    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
	}
	/*鼠标悬浮在滑块上时滑块的样式*/
	.nui-scroll2::-webkit-scrollbar-thumb:hover {
	  background-color: rgba(0,0,0,.4);
	    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
	}
	/*正常时候的主干部分*/
	.nui-scroll2::-webkit-scrollbar-track {
	    border-radius: 10px;
	    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0);
	    background-color: white;
	}
	/*鼠标悬浮在滚动条上的主干部分*/
	.nui-scroll2::-webkit-scrollbar-track:hover {
	    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.4);
	    background-color: rgba(0,0,0,.01);
	}
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/bigScreen.vue